<template>
  <v-data-table
    :headers="headers"
    :items="dataItems"
    :items-per-page.sync="itemsPerPage"
    :page.sync="page"
    :search="search"
    hide-default-footer
  >
    <template v-slot:item.responseRate="{ item }">
      {{ item.responseRate }}%
    </template>
    <template v-if="reports" v-slot:item.actions="{ item }">
      <div class="text-no-wrap">
        <v-tooltip top v-for="report in reports" :key="report.label">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="
                $emit('toggle-report', {
                  districtId: item.districtId,
                  schoolId: item.id,
                  name: report.name,
                })
              "
              :disabled="disableReport(item)"
              ><font-awesome-icon
                v-if="report.icon"
                :icon="report.icon"
              ></font-awesome-icon
            ></v-btn>
          </template>
          <span>{{ report.label }}</span>
        </v-tooltip>
      </div>
    </template>
    <template v-slot:footer="{ props }">
      <v-divider></v-divider>
      <v-card-title class="text-body-1 black--text">
        <v-btn @click="genCSV" color="grey lighten-3" elevation="0" class="mr-4">Export Data</v-btn>
        <span class="grey--text">Items per page</span>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              text
              color="primary"
              class="ml-2"
              v-bind="attrs"
              v-on="on"
            >
              {{ itemsPerPage }}
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(number, index) in itemsPerPageArray"
              :key="index"
              @click="itemsPerPage = number"
              :class="{ 'grey lighten-2': itemsPerPage === number }"
            >
              <v-list-item-title>{{ number }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-spacer></v-spacer>

        <span class="mr-4 grey--text">
          Page {{ props.pagination.page }} of
          {{ props.pagination.pageCount }}
        </span>
        <v-btn
          fab
          :disabled="page === 1"
          elevation="0"
          small
          color="primary"
          class="mr-1"
          @click="page--"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          fab
          :disabled="page === numberOfPages"
          elevation="0"
          small
          color="primary"
          class="ml-1"
          @click="page++"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-title>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "ResponseRateGrid",
  props: {
    items: Array,
    search: String,
    reports: Object,
    disableReport: Function,
  },
  data: () => ({
    page: 1,
    itemsPerPage: 25,
    itemsPerPageArray: [10, 15, 25, 50, 100],
  }),
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    headers() {
      let headers = [
        { text: "District", value: "districtName" },
        { text: "School", value: "name" },
        { text: "Invitees", value: "invitees" },
        { text: "Responses", value: "responses" },
        { text: "Response Rate", value: "responseRate" },
      ];

      if (this.reports) {
        headers.push({ text: "Reports", value: "actions", align: "center" });
      }

      return headers;
    },
    dataItems() {
      return this.items.slice().map((x) => {
        if (x.responseRate && x.responseRate.replace)
          x.responseRate = +x.responseRate.replace("%", "");
        return x;
      });
    },
  },
  methods: {
    genCSV() {
      const lines = [];

      const buildLine = (parts) => parts.map((x) => `"${x}"`).join(",");

      if (this.dataItems?.length) {
        // Add header
        let keys = [];
        for (let key in this.dataItems[0]) keys.push(key);
        
        lines.push(buildLine(keys.map(key => {
          let res = key.replace(/([A-Z])/g, " $1");
          return res.charAt(0).toUpperCase() + res.slice(1);
        })));

        //add rows
        for (let i = 0; i < this.dataItems.length; i++) {
          let line = [];

          for (let ii = 0; ii < keys.length; ii++) {
            let val = this.dataItems[i][keys[ii]];
            if (keys[ii] == "responseRate") val += "%";
            line.push(val);
          }

          lines.push(buildLine(line));
        }
      }

      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(lines.join("\n"))
      );
      element.setAttribute("download", "ResponseRate.csv");

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
  },
};
</script>
